module.exports = __webpack_public_path__ + "img/file_ext_big_zip.607beb9b.png";